import { NgModule } from '@angular/core';
import { ReferenceRequestsRoutingModule } from '@references/public/reference-requests/reference-requests-routing.module';
import { ReferenceRequestsComponent } from '@references/public/reference-requests/reference-requests.component';
import { ReferencesSharedModule } from '@references/shared/shared.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SignaturePadModule } from 'ngx-signaturepad';

@NgModule({
  declarations: [ReferenceRequestsComponent],
  imports: [
    ReferencesSharedModule,
    ReferenceRequestsRoutingModule,
    BsDatepickerModule,
    SignaturePadModule
  ]
})
export class ReferenceRequestsModule {}
